import React from 'react';
import { H2, P, UL, LI, FeatureLink, Callout } from './_shared';

export default {
  slug: 'managing-pipeline',
  title: 'Managing your pipeline',
  category: 'leads-deals',
  summary: 'The Deals board, stages, customization, and how the AI flags at-risk deals.',
  searchTerms: ['pipeline', 'kanban', 'stages', 'board', 'forecast'],
  related: ['creating-deals', 'health-score', 'broker-dashboard'],
  Body: () => (
    <>
      <P>
        <FeatureLink to="/deals">Deals</FeatureLink> is a Kanban board where
        every card is one transaction. Drag cards between columns to change
        stage; we log it automatically and the activity feed updates.
      </P>

      <H2>Default stages</H2>
      <UL>
        <LI><strong>New</strong> — just created, no offer yet</LI>
        <LI><strong>Showing</strong> — actively touring properties</LI>
        <LI><strong>Offer</strong> — offer drafted or submitted</LI>
        <LI><strong>Under Contract</strong> — accepted, in escrow</LI>
        <LI><strong>Closed Won</strong> — closed and commission paid</LI>
        <LI><strong>Closed Lost</strong> — deal fell through; capture the reason</LI>
      </UL>

      <H2>Customizing stages</H2>
      <P>
        Settings → Pipelines lets you rename, reorder, add, or remove stages.
        If you have multiple deal types (buyer vs. seller vs. rental), create
        separate pipelines and switch between them at the top of the board.
      </P>

      <H2>At-risk flags</H2>
      <P>
        A coral dot on a card means the AI thinks the deal is going cold —
        long silence from the client, missed appointment, contract milestone
        passed. Hover for the reason. These flags feed the{' '}
        <FeatureLink to="/help/broker-dashboard">broker dashboard's at-risk
        list</FeatureLink>.
      </P>

      <Callout kind="tip">
        Spending too much time dragging cards? Try keyboard nav — focus a
        card and use the arrow keys to move it between columns.
      </Callout>
    </>
  ),
};
